export const questionsCategoryA: Record<string, PolicyFormQuestion> = {
  medicalHeartAttackFirstInsured: {
    id: 'medical-heart-attack-first-insured',
    questionRef: 'medicalHeartAttackFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for heart attack?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalHighBloodPressureFirstInsured: {
    id: 'medical-high-blood-pressure-first-insured',
    questionRef: 'medicalHighBloodPressureFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for high blood pressure?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalStrokeFirstInsured: {
    id: 'medical-stroke-first-insured',
    questionRef: 'medicalStrokeFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for stroke?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalTransientIschemicAttackTiaFirstInsured: {
    id: 'medical-transient-ischemic-attack-tia-first-insured',
    questionRef: 'medicalTransientIschemicAttackTiaFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for transient ischemic attack (TIA)?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalCongestiveHeartFailureFirstInsured: {
    id: 'medical-congestive-heart-failure-first-insured',
    questionRef: 'medicalCongestiveHeartFailureFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for congestive heart failure?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalIrregularHeartbeatFirstInsured: {
    id: 'medical-irregular-heartbeat-first-insured',
    questionRef: 'medicalIrregularHeartbeatFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for irregular heartbeat?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalAneurysmFirstInsured: {
    id: 'medical-aneurysm-first-insured',
    questionRef: 'medicalAneurysmFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for aneurysm?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalCarotidArteryDiseaseFirstInsured: {
    id: 'medical-carotid-artery-disease-first-insured',
    questionRef: 'medicalCarotidArteryDiseaseFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for carotid artery disease?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalCardiomyopathyFirstInsured: {
    id: 'medical-cardiomyopathy-first-insured',
    questionRef: 'medicalCardiomyopathyFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for cardiomyopathy?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalHeartMurmurFirstInsured: {
    id: 'medical-heart-murmur-first-insured',
    questionRef: 'medicalHeartMurmurFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for heart murmur?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalCoronaryArteryDiseaseFirstInsured: {
    id: 'medical-coronary-artery-disease-first-insured',
    questionRef: 'medicalCoronaryArteryDiseaseFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for coronary artery disease?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalAtrialFibrillationFirstInsured: {
    id: 'medical-atrial-fibrillation-first-insured',
    questionRef: 'medicalAtrialFibrillationFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for atrial fibrillation?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalValvularHeartDiseaseFirstInsured: {
    id: 'medical-valvular-heart-disease-first-insured',
    questionRef: 'medicalValvularHeartDiseaseFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for valvular heart disease?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalCongenitalHeartDiseaseFirstInsured: {
    id: 'medical-congenital-heart-disease-first-insured',
    questionRef: 'medicalCongenitalHeartDiseaseFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for congenital heart disease?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalAtherosclerosisFirstInsured: {
    id: 'medical-atherosclerosis-first-insured',
    questionRef: 'medicalAtherosclerosisFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for atherosclerosis?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalPeripheralVascularDiseaseFirstInsured: {
    id: 'medical-peripheral-vascular-disease-first-insured',
    questionRef: 'medicalPeripheralVascularDiseaseFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for peripheral vascular disease?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalVenousInsufficiencyFirstInsured: {
    id: 'medical-venous-insufficiency-first-insured',
    questionRef: 'medicalVenousInsufficiencyFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for venous insufficiency?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalDeepVeinThrombosisFirstInsured: {
    id: 'medical-deep-vein-thrombosis-first-insured',
    questionRef: 'medicalDeepVeinThrombosisFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for deep vein thrombosis?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalPulmonaryEmbolismFirstInsured: {
    id: 'medical-pulmonary-embolism-first-insured',
    questionRef: 'medicalPulmonaryEmbolismFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for pulmonary embolism?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalCancerFirstInsured: {
    id: 'medical-cancer-first-insured',
    questionRef: 'medicalCancerFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for cancer?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalTumorFirstInsured: {
    id: 'medical-tumor-first-insured',
    questionRef: 'medicalTumorFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for tumor?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalLymphomaFirstInsured: {
    id: 'medical-lymphoma-first-insured',
    questionRef: 'medicalLymphomaFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for lymphoma?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalEnlargementOfTheLymphGlandFirstInsured: {
    id: 'medical-enlargement-of-the-lymph-gland-first-insured',
    questionRef: 'medicalEnlargementOfTheLymphGlandFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for enlargement of the lymph gland?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalMultipleMyelomaFirstInsured: {
    id: 'medical-multiple-myeloma-first-insured',
    questionRef: 'medicalMultipleMyelomaFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for multiple myeloma?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalLeukemiaFirstInsured: {
    id: 'medical-leukemia-first-insured',
    questionRef: 'medicalLeukemiaFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for leukemia?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalAnemiaFirstInsured: {
    id: 'medical-anemia-first-insured',
    questionRef: 'medicalAnemiaFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for anemia?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalPolycythemiaFirstInsured: {
    id: 'medical-polycythemia-first-insured',
    questionRef: 'medicalPolycythemiaFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for polycythemia?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalThrombocytopeniaFirstInsured: {
    id: 'medical-thrombocytopenia-first-insured',
    questionRef: 'medicalThrombocytopeniaFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for thrombocytopenia?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalDiabetesFirstInsured: {
    id: 'medical-diabetes-first-insured',
    questionRef: 'medicalDiabetesFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for diabetes?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalChronicKidneyDiseaseFirstInsured: {
    id: 'medical-chronic-kidney-disease-first-insured',
    questionRef: 'medicalChronicKidneyDiseaseFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for chronic kidney disease?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalPolycysticKidneyDiseaseFirstInsured: {
    id: 'medical-polycystic-kidney-disease-first-insured',
    questionRef: 'medicalPolycysticKidneyDiseaseFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for polycystic kidney disease?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalKidneyFailureFirstInsured: {
    id: 'medical-kidney-failure-first-insured',
    questionRef: 'medicalKidneyFailureFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for kidney failure?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalNephritisFirstInsured: {
    id: 'medical-nephritis-first-insured',
    questionRef: 'medicalNephritisFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for nephritis?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalNephroticSyndromeFirstInsured: {
    id: 'medical-nephrotic-syndrome-first-insured',
    questionRef: 'medicalNephroticSyndromeFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for nephrotic syndrome?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalHematuriaFirstInsured: {
    id: 'medical-hematuria-first-insured',
    questionRef: 'medicalHematuriaFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for hematuria?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalUrinaryIncontinenceFirstInsured: {
    id: 'medical-urinary-incontinence-first-insured',
    questionRef: 'medicalUrinaryIncontinenceFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for urinary incontinence?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalNeurogenicBladderFirstInsured: {
    id: 'medical-neurogenic-bladder-first-insured',
    questionRef: 'medicalNeurogenicBladderFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for neurogenic bladder?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalShortnessOfBreathFirstInsured: {
    id: 'medical-shortness-of-breath-first-insured',
    questionRef: 'medicalShortnessOfBreathFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for shortness of breath?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalPulmonaryFibrosisFirstInsured: {
    id: 'medical-pulmonary-fibrosis-first-insured',
    questionRef: 'medicalPulmonaryFibrosisFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for pulmonary fibrosis?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalSarcoidosisFirstInsured: {
    id: 'medical-sarcoidosis-first-insured',
    questionRef: 'medicalSarcoidosisFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for sarcoidosis?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalChronicObstructivePulmonaryDiseaseCopdFirstInsured: {
    id: 'medical-chronic-obstructive-pulmonary-disease-copd-first-insured',
    questionRef: 'medicalChronicObstructivePulmonaryDiseaseCopdFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for chronic obstructive pulmonary disease (COPD)?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalAsthmaFirstInsured: {
    id: 'medical-asthma-first-insured',
    questionRef: 'medicalAsthmaFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for asthma?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalSleepApneaFirstInsured: {
    id: 'medical-sleep-apnea-first-insured',
    questionRef: 'medicalSleepApneaFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for sleep apnea?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalEmphysemaFirstInsured: {
    id: 'medical-emphysema-first-insured',
    questionRef: 'medicalEmphysemaFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for emphysema?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalPneumoniaFirstInsured: {
    id: 'medical-pneumonia-first-insured',
    questionRef: 'medicalPneumoniaFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for pneumonia?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalTuberculosisFirstInsured: {
    id: 'medical-tuberculosis-first-insured',
    questionRef: 'medicalTuberculosisFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for tuberculosis?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalIntestinalBleedingFirstInsured: {
    id: 'medical-intestinal-bleeding-first-insured',
    questionRef: 'medicalIntestinalBleedingFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for intestinal bleeding?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalUlcerFirstInsured: {
    id: 'medical-ulcer-first-insured',
    questionRef: 'medicalUlcerFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for ulcer?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalHepatitisFirstInsured: {
    id: 'medical-hepatitis-first-insured',
    questionRef: 'medicalHepatitisFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for hepatitis?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalGastroparesisFirstInsured: {
    id: 'medical-gastroparesis-first-insured',
    questionRef: 'medicalGastroparesisFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for gastroparesis?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalBarrettEsophagusFirstInsured: {
    id: 'medical-barrett-esophagus-first-insured',
    questionRef: 'medicalBarrettEsophagusFirstInsured',
    title:
      "During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for Barrett's Esophagus?",
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalCrohnsDiseaseFirstInsured: {
    id: 'medical-crohn-s-disease-first-insured',
    questionRef: 'medicalCrohnsDiseaseFirstInsured',
    title:
      "During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for Crohn's disease?",
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalUlcerativeColitisFirstInsured: {
    id: 'medical-ulcerative-colitis-first-insured',
    questionRef: 'medicalUlcerativeColitisFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for ulcerative colitis?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalCirrhosisFirstInsured: {
    id: 'medical-cirrhosis-first-insured',
    questionRef: 'medicalCirrhosisFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for cirrhosis?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalPancreatitisFirstInsured: {
    id: 'medical-pancreatitis-first-insured',
    questionRef: 'medicalPancreatitisFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for pancreatitis?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalLiverFailureFirstInsured: {
    id: 'medical-liver-failure-first-insured',
    questionRef: 'medicalLiverFailureFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for liver failure?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalSchizophreniaFirstInsured: {
    id: 'medical-schizophrenia-first-insured',
    questionRef: 'medicalSchizophreniaFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for schizophrenia?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalBipolarDisorderFirstInsured: {
    id: 'medical-bipolar-disorder-first-insured',
    questionRef: 'medicalBipolarDisorderFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for bipolar disorder?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalDepressionFirstInsured: {
    id: 'medical-depression-first-insured',
    questionRef: 'medicalDepressionFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for depression?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalAnxietyFirstInsured: {
    id: 'medical-anxiety-first-insured',
    questionRef: 'medicalAnxietyFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for anxiety?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalSuicideAttemptFirstInsured: {
    id: 'medical-suicide-attempt-first-insured',
    questionRef: 'medicalSuicideAttemptFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for suicide attempt?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalAnorexiaFirstInsured: {
    id: 'medical-anorexia-first-insured',
    questionRef: 'medicalAnorexiaFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for anorexia?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalPostTraumaticStressDisorderFirstInsured: {
    id: 'medical-post-traumatic-stress-disorder-first-insured',
    questionRef: 'medicalPostTraumaticStressDisorderFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for post-traumatic stress disorder?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalChronicFatigueFirstInsured: {
    id: 'medical-chronic-fatigue-first-insured',
    questionRef: 'medicalChronicFatigueFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for chronic fatigue',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalFibromyalgiaFirstInsured: {
    id: 'medical-fibromyalgia-first-insured',
    questionRef: 'medicalFibromyalgiaFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for fibromyalgia',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalDizzinessFirstInsured: {
    id: 'medical-dizziness-first-insured',
    questionRef: 'medicalDizzinessFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for dizziness',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalVertigoFirstInsured: {
    id: 'medical-vertigo-first-insured',
    questionRef: 'medicalVertigoFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for vertigo',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalMigrainesFirstInsured: {
    id: 'medical-migraines-first-insured',
    questionRef: 'medicalMigrainesFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for migraines',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalTraumaticBrainInjuryFirstInsured: {
    id: 'medical-traumatic-brain-injury-first-insured',
    questionRef: 'medicalTraumaticBrainInjuryFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for traumatic brain injury',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalGaitDisturbanceFirstInsured: {
    id: 'medical-gait-disturbance-first-insured',
    questionRef: 'medicalGaitDisturbanceFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for gait disturbance',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalNeurofibromatosisFirstInsured: {
    id: 'medical-neurofibromatosis-first-insured',
    questionRef: 'medicalNeurofibromatosisFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for neurofibromatosis',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalFaintingFirstInsured: {
    id: 'medical-fainting-first-insured',
    questionRef: 'medicalFaintingFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for fainting',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalConvulsionsEpilepsyFirstInsured: {
    id: 'medical-convulsions-or-epilepsy-first-insured',
    questionRef: 'medicalConvulsionsEpilepsyFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for convulsions or epilepsy',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalParalysisFirstInsured: {
    id: 'medical-paralysis-first-insured',
    questionRef: 'medicalParalysisFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for paralysis',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalMyastheniaGravisFirstInsured: {
    id: 'medical-myasthenia-gravis-first-insured',
    questionRef: 'medicalMyastheniaGravisFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for myasthenia gravis',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalPeripheralNeuropathyFirstInsured: {
    id: 'medical-peripheral-neuropathy-first-insured',
    questionRef: 'medicalPeripheralNeuropathyFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for peripheral neuropathy',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalParkinsonDiseaseFirstInsured: {
    id: 'medical-parkinson-disease-first-insured',
    questionRef: 'medicalParkinsonDiseaseFirstInsured',
    title:
      "During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for Parkinson's disease",
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalMultipleSclerosisFirstInsured: {
    id: 'medical-multiple-sclerosis-first-insured',
    questionRef: 'medicalMultipleSclerosisFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for multiple sclerosis',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalALSFirstInsured: {
    id: 'medical-als-first-insured',
    questionRef: 'medicalALSFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for ALS (amyotrophic lateral sclerosis)',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalGuillainBarreSyndromeFirstInsured: {
    id: 'medical-guillain-barre-syndrome-first-insured',
    questionRef: 'medicalGuillainBarreSyndromeFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for Guillain-Barre Syndrome',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalAlzheimerDiseaseFirstInsured: {
    id: 'medical-alzheimer-disease-first-insured',
    questionRef: 'medicalAlzheimerDiseaseFirstInsured',
    title:
      "During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for Alzheimer's disease",
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalDementiaFirstInsured: {
    id: 'medical-dementia-first-insured',
    questionRef: 'medicalDementiaFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for dementia',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalMemoryLossFirstInsured: {
    id: 'medical-memory-loss-first-insured',
    questionRef: 'medicalMemoryLossFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for memory loss',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalCognitiveImpairmentFirstInsured: {
    id: 'medical-cognitive-impairment-first-insured',
    questionRef: 'medicalCognitiveImpairmentFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for cognitive impairment',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalTremorsFirstInsured: {
    id: 'medical-tremors-first-insured',
    questionRef: 'medicalTremorsFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for tremors',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalArthritisFirstInsured: {
    id: 'medical-arthritis-first-insured',
    questionRef: 'medicalArthritisFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for arthritis',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalLossOfLimbFirstInsured: {
    id: 'medical-loss-of-limb-first-insured',
    questionRef: 'medicalLossOfLimbFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for loss of limb',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalOrganTransplantFirstInsured: {
    id: 'medical-organ-transplant-first-insured',
    questionRef: 'medicalOrganTransplantFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for organ transplant',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalMyopathyFirstInsured: {
    id: 'medical-myopathy-first-insured',
    questionRef: 'medicalMyopathyFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for myopathy',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalPolymyalgiaRheumaticaFirstInsured: {
    id: 'medical-polymyalgia-rheumatica-first-insured',
    questionRef: 'medicalPolymyalgiaRheumaticaFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for polymyalgia rheumatica',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalMuscularDystrophyFirstInsured: {
    id: 'medical-muscular-dystrophy-first-insured',
    questionRef: 'medicalMuscularDystrophyFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for muscular dystrophy',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalVertebralFracturesFirstInsured: {
    id: 'medical-vertebral-fractures-first-insured',
    questionRef: 'medicalVertebralFracturesFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for vertebral fractures',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalOsteoporosisFirstInsured: {
    id: 'medical-osteoporosis-first-insured',
    questionRef: 'medicalOsteoporosisFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for osteoporosis',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalSystemicLupusFirstInsured: {
    id: 'medical-systemic-lupus-first-insured',
    questionRef: 'medicalSystemicLupusFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for systemic lupus',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalSclerodermaFirstInsured: {
    id: 'medical-scleroderma-first-insured',
    questionRef: 'medicalSclerodermaFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for scleroderma',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalRetinopathyFirstInsured: {
    id: 'medical-retinopathy-first-insured',
    questionRef: 'medicalRetinopathyFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for retinopathy',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalLossOfVisionFirstInsured: {
    id: 'medical-loss-of-vision-first-insured',
    questionRef: 'medicalLossOfVisionFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for loss of vision',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalWetMacularDegenerationFirstInsured: {
    id: 'medical-wet-macular-degeneration-first-insured',
    questionRef: 'medicalWetMacularDegenerationFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for wet macular degeneration',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalKaposiSarcomaFirstInsured: {
    id: 'medical-kaposi-sarcoma-first-insured',
    questionRef: 'medicalKaposiSarcomaFirstInsured',
    title:
      "During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for Kaposi's sarcoma",
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalPneumocystisCariniiPneumoniaFirstInsured: {
    id: 'medical-pneumocystis-carinii-pneumonia-first-insured',
    questionRef: 'medicalPneumocystisCariniiPneumoniaFirstInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for pneumocystis carinii pneumonia',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalHeartAttackSecondInsured: {
    id: 'medical-heart-attack-second-insured',
    questionRef: 'medicalHeartAttackSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for heart attack?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalHighBloodPressureSecondInsured: {
    id: 'medical-high-blood-pressure-second-insured',
    questionRef: 'medicalHighBloodPressureSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for high blood pressure?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalStrokeSecondInsured: {
    id: 'medical-stroke-second-insured',
    questionRef: 'medicalStrokeSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for stroke?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalTransientIschemicAttackTiaSecondInsured: {
    id: 'medical-transient-ischemic-attack-tia-second-insured',
    questionRef: 'medicalTransientIschemicAttackTiaSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for transient ischemic attack (TIA)?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalCongestiveHeartFailureSecondInsured: {
    id: 'medical-congestive-heart-failure-second-insured',
    questionRef: 'medicalCongestiveHeartFailureSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for congestive heart failure?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalIrregularHeartbeatSecondInsured: {
    id: 'medical-irregular-heartbeat-second-insured',
    questionRef: 'medicalIrregularHeartbeatSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for irregular heartbeat?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalAneurysmSecondInsured: {
    id: 'medical-aneurysm-second-insured',
    questionRef: 'medicalAneurysmSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for aneurysm?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalCarotidArteryDiseaseSecondInsured: {
    id: 'medical-carotid-artery-disease-second-insured',
    questionRef: 'medicalCarotidArteryDiseaseSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for carotid artery disease?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalCardiomyopathySecondInsured: {
    id: 'medical-cardiomyopathy-second-insured',
    questionRef: 'medicalCardiomyopathySecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for cardiomyopathy?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalHeartMurmurSecondInsured: {
    id: 'medical-heart-murmur-second-insured',
    questionRef: 'medicalHeartMurmurSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for heart murmur?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalCoronaryArteryDiseaseSecondInsured: {
    id: 'medical-coronary-artery-disease-second-insured',
    questionRef: 'medicalCoronaryArteryDiseaseSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for coronary artery disease?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalAtrialFibrillationSecondInsured: {
    id: 'medical-atrial-fibrillation-second-insured',
    questionRef: 'medicalAtrialFibrillationSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for atrial fibrillation?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalValvularHeartDiseaseSecondInsured: {
    id: 'medical-valvular-heart-disease-second-insured',
    questionRef: 'medicalValvularHeartDiseaseSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for valvular heart disease?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalCongenitalHeartDiseaseSecondInsured: {
    id: 'medical-congenital-heart-disease-second-insured',
    questionRef: 'medicalCongenitalHeartDiseaseSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for congenital heart disease?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalAtherosclerosisSecondInsured: {
    id: 'medical-atherosclerosis-second-insured',
    questionRef: 'medicalAtherosclerosisSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for atherosclerosis?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalPeripheralVascularDiseaseSecondInsured: {
    id: 'medical-peripheral-vascular-disease-second-insured',
    questionRef: 'medicalPeripheralVascularDiseaseSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for peripheral vascular disease?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalVenousInsufficiencySecondInsured: {
    id: 'medical-venous-insufficiency-second-insured',
    questionRef: 'medicalVenousInsufficiencySecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for venous insufficiency?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalDeepVeinThrombosisSecondInsured: {
    id: 'medical-deep-vein-thrombosis-second-insured',
    questionRef: 'medicalDeepVeinThrombosisSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for deep vein thrombosis?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalPulmonaryEmbolismSecondInsured: {
    id: 'medical-pulmonary-embolism-second-insured',
    questionRef: 'medicalPulmonaryEmbolismSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for pulmonary embolism?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalCancerSecondInsured: {
    id: 'medical-cancer-second-insured',
    questionRef: 'medicalCancerSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for cancer?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalTumorSecondInsured: {
    id: 'medical-tumor-second-insured',
    questionRef: 'medicalTumorSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for tumor?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalLymphomaSecondInsured: {
    id: 'medical-lymphoma-second-insured',
    questionRef: 'medicalLymphomaSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for lymphoma?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalEnlargementOfTheLymphGlandSecondInsured: {
    id: 'medical-enlargement-of-the-lymph-gland-second-insured',
    questionRef: 'medicalEnlargementOfTheLymphGlandSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for enlargement of the lymph gland?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalMultipleMyelomaSecondInsured: {
    id: 'medical-multiple-myeloma-second-insured',
    questionRef: 'medicalMultipleMyelomaSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for multiple myeloma?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalLeukemiaSecondInsured: {
    id: 'medical-leukemia-second-insured',
    questionRef: 'medicalLeukemiaSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for leukemia?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalAnemiaSecondInsured: {
    id: 'medical-anemia-second-insured',
    questionRef: 'medicalAnemiaSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for anemia?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalPolycythemiaSecondInsured: {
    id: 'medical-polycythemia-second-insured',
    questionRef: 'medicalPolycythemiaSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for polycythemia?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalThrombocytopeniaSecondInsured: {
    id: 'medical-thrombocytopenia-second-insured',
    questionRef: 'medicalThrombocytopeniaSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for thrombocytopenia?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalDiabetesSecondInsured: {
    id: 'medical-diabetes-second-insured',
    questionRef: 'medicalDiabetesSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for diabetes?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalChronicKidneyDiseaseSecondInsured: {
    id: 'medical-chronic-kidney-disease-second-insured',
    questionRef: 'medicalChronicKidneyDiseaseSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for chronic kidney disease?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalPolycysticKidneyDiseaseSecondInsured: {
    id: 'medical-polycystic-kidney-disease-second-insured',
    questionRef: 'medicalPolycysticKidneyDiseaseSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for polycystic kidney disease?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalKidneyFailureSecondInsured: {
    id: 'medical-kidney-failure-second-insured',
    questionRef: 'medicalKidneyFailureSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for kidney failure?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalNephritisSecondInsured: {
    id: 'medical-nephritis-second-insured',
    questionRef: 'medicalNephritisSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for nephritis?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalNephroticSyndromeSecondInsured: {
    id: 'medical-nephrotic-syndrome-second-insured',
    questionRef: 'medicalNephroticSyndromeSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for nephrotic syndrome?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalHematuriaSecondInsured: {
    id: 'medical-hematuria-second-insured',
    questionRef: 'medicalHematuriaSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for hematuria?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalUrinaryIncontinenceSecondInsured: {
    id: 'medical-urinary-incontinence-second-insured',
    questionRef: 'medicalUrinaryIncontinenceSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for urinary incontinence?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalNeurogenicBladderSecondInsured: {
    id: 'medical-neurogenic-bladder-second-insured',
    questionRef: 'medicalNeurogenicBladderSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for neurogenic bladder?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalShortnessOfBreathSecondInsured: {
    id: 'medical-shortness-of-breath-second-insured',
    questionRef: 'medicalShortnessOfBreathSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for shortness of breath?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalPulmonaryFibrosisSecondInsured: {
    id: 'medical-pulmonary-fibrosis-second-insured',
    questionRef: 'medicalPulmonaryFibrosisSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for pulmonary fibrosis?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalSarcoidosisSecondInsured: {
    id: 'medical-sarcoidosis-second-insured',
    questionRef: 'medicalSarcoidosisSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for sarcoidosis?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalChronicObstructivePulmonaryDiseaseCopdSecondInsured: {
    id: 'medical-chronic-obstructive-pulmonary-disease-copd-second-insured',
    questionRef: 'medicalChronicObstructivePulmonaryDiseaseCopdSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for chronic obstructive pulmonary disease (COPD)?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalAsthmaSecondInsured: {
    id: 'medical-asthma-second-insured',
    questionRef: 'medicalAsthmaSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for asthma?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalSleepApneaSecondInsured: {
    id: 'medical-sleep-apnea-second-insured',
    questionRef: 'medicalSleepApneaSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for sleep apnea?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalEmphysemaSecondInsured: {
    id: 'medical-emphysema-second-insured',
    questionRef: 'medicalEmphysemaSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for emphysema?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalPneumoniaSecondInsured: {
    id: 'medical-pneumonia-second-insured',
    questionRef: 'medicalPneumoniaSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for pneumonia?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalTuberculosisSecondInsured: {
    id: 'medical-tuberculosis-second-insured',
    questionRef: 'medicalTuberculosisSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for tuberculosis?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalIntestinalBleedingSecondInsured: {
    id: 'medical-intestinal-bleeding-second-insured',
    questionRef: 'medicalIntestinalBleedingSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for intestinal bleeding?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalUlcerSecondInsured: {
    id: 'medical-ulcer-second-insured',
    questionRef: 'medicalUlcerSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for ulcer?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalHepatitisSecondInsured: {
    id: 'medical-hepatitis-second-insured',
    questionRef: 'medicalHepatitisSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for hepatitis?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalGastroparesisSecondInsured: {
    id: 'medical-gastroparesis-second-insured',
    questionRef: 'medicalGastroparesisSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for gastroparesis?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalBarrettEsophagusSecondInsured: {
    id: 'medical-barrett-esophagus-second-insured',
    questionRef: 'medicalBarrettEsophagusSecondInsured',
    title:
      "During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for Barrett's Esophagus?",
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalCrohnsDiseaseSecondInsured: {
    id: 'medical-crohn-s-disease-second-insured',
    questionRef: 'medicalCrohnsDiseaseSecondInsured',
    title:
      "During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for Crohn's disease?",
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalUlcerativeColitisSecondInsured: {
    id: 'medical-ulcerative-colitis-second-insured',
    questionRef: 'medicalUlcerativeColitisSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for ulcerative colitis?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalCirrhosisSecondInsured: {
    id: 'medical-cirrhosis-second-insured',
    questionRef: 'medicalCirrhosisSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for cirrhosis?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalPancreatitisSecondInsured: {
    id: 'medical-pancreatitis-second-insured',
    questionRef: 'medicalPancreatitisSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for pancreatitis?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalLiverFailureSecondInsured: {
    id: 'medical-liver-failure-second-insured',
    questionRef: 'medicalLiverFailureSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for liver failure?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalSchizophreniaSecondInsured: {
    id: 'medical-schizophrenia-second-insured',
    questionRef: 'medicalSchizophreniaSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for schizophrenia?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalBipolarDisorderSecondInsured: {
    id: 'medical-bipolar-disorder-second-insured',
    questionRef: 'medicalBipolarDisorderSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for bipolar disorder?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalDepressionSecondInsured: {
    id: 'medical-depression-second-insured',
    questionRef: 'medicalDepressionSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for depression?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalAnxietySecondInsured: {
    id: 'medical-anxiety-second-insured',
    questionRef: 'medicalAnxietySecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for anxiety?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalSuicideAttemptSecondInsured: {
    id: 'medical-suicide-attempt-second-insured',
    questionRef: 'medicalSuicideAttemptSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for suicide attempt?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalAnorexiaSecondInsured: {
    id: 'medical-anorexia-second-insured',
    questionRef: 'medicalAnorexiaSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for anorexia?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalPostTraumaticStressDisorderSecondInsured: {
    id: 'medical-post-traumatic-stress-disorder-second-insured',
    questionRef: 'medicalPostTraumaticStressDisorderSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for post-traumatic stress disorder?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalChronicFatigueSecondInsured: {
    id: 'medical-chronic-fatigue-second-insured',
    questionRef: 'medicalChronicFatigueSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for chronic fatigue',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalFibromyalgiaSecondInsured: {
    id: 'medical-fibromyalgia-second-insured',
    questionRef: 'medicalFibromyalgiaSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for fibromyalgia',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalDizzinessSecondInsured: {
    id: 'medical-dizziness-second-insured',
    questionRef: 'medicalDizzinessSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for dizziness',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalVertigoSecondInsured: {
    id: 'medical-vertigo-second-insured',
    questionRef: 'medicalVertigoSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for vertigo',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalMigrainesSecondInsured: {
    id: 'medical-migraines-second-insured',
    questionRef: 'medicalMigrainesSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for migraines',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalTraumaticBrainInjurySecondInsured: {
    id: 'medical-traumatic-brain-injury-second-insured',
    questionRef: 'medicalTraumaticBrainInjurySecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for traumatic brain injury',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalGaitDisturbanceSecondInsured: {
    id: 'medical-gait-disturbance-second-insured',
    questionRef: 'medicalGaitDisturbanceSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for gait disturbance',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalNeurofibromatosisSecondInsured: {
    id: 'medical-neurofibromatosis-second-insured',
    questionRef: 'medicalNeurofibromatosisSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for neurofibromatosis',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalFaintingSecondInsured: {
    id: 'medical-fainting-second-insured',
    questionRef: 'medicalFaintingSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for fainting',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalConvulsionsEpilepsySecondInsured: {
    id: 'medical-convulsions-or-epilepsy-second-insured',
    questionRef: 'medicalConvulsionsEpilepsySecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for convulsions or epilepsy',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalParalysisSecondInsured: {
    id: 'medical-paralysis-second-insured',
    questionRef: 'medicalParalysisSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for paralysis',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalMyastheniaGravisSecondInsured: {
    id: 'medical-myasthenia-gravis-second-insured',
    questionRef: 'medicalMyastheniaGravisSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for myasthenia gravis',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalPeripheralNeuropathySecondInsured: {
    id: 'medical-peripheral-neuropathy-second-insured',
    questionRef: 'medicalPeripheralNeuropathySecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for peripheral neuropathy',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalParkinsonDiseaseSecondInsured: {
    id: 'medical-parkinson-disease-second-insured',
    questionRef: 'medicalParkinsonDiseaseSecondInsured',
    title:
      "During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for Parkinson's disease",
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalMultipleSclerosisSecondInsured: {
    id: 'medical-multiple-sclerosis-second-insured',
    questionRef: 'medicalMultipleSclerosisSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for multiple sclerosis',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalALSSecondInsured: {
    id: 'medical-als-second-insured',
    questionRef: 'medicalALSSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for ALS (amyotrophic lateral sclerosis)',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalGuillainBarreSyndromeSecondInsured: {
    id: 'medical-guillain-barre-syndrome-second-insured',
    questionRef: 'medicalGuillainBarreSyndromeSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for Guillain-Barre Syndrome',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalAlzheimerDiseaseSecondInsured: {
    id: 'medical-alzheimer-disease-second-insured',
    questionRef: 'medicalAlzheimerDiseaseSecondInsured',
    title:
      "During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for Alzheimer's disease",
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalDementiaSecondInsured: {
    id: 'medical-dementia-second-insured',
    questionRef: 'medicalDementiaSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for dementia',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalMemoryLossSecondInsured: {
    id: 'medical-memory-loss-second-insured',
    questionRef: 'medicalMemoryLossSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for memory loss',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalCognitiveImpairmentSecondInsured: {
    id: 'medical-cognitive-impairment-second-insured',
    questionRef: 'medicalCognitiveImpairmentSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for cognitive impairment',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalTremorsSecondInsured: {
    id: 'medical-tremors-second-insured',
    questionRef: 'medicalTremorsSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for tremors',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalArthritisSecondInsured: {
    id: 'medical-arthritis-second-insured',
    questionRef: 'medicalArthritisSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for arthritis',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalLossOfLimbSecondInsured: {
    id: 'medical-loss-of-limb-second-insured',
    questionRef: 'medicalLossOfLimbSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for loss of limb',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalOrganTransplantSecondInsured: {
    id: 'medical-organ-transplant-second-insured',
    questionRef: 'medicalOrganTransplantSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for organ transplant',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalMyopathySecondInsured: {
    id: 'medical-myopathy-second-insured',
    questionRef: 'medicalMyopathySecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for myopathy',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalPolymyalgiaRheumaticaSecondInsured: {
    id: 'medical-polymyalgia-rheumatica-second-insured',
    questionRef: 'medicalPolymyalgiaRheumaticaSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for polymyalgia rheumatica',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalMuscularDystrophySecondInsured: {
    id: 'medical-muscular-dystrophy-second-insured',
    questionRef: 'medicalMuscularDystrophySecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for muscular dystrophy',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalVertebralFracturesSecondInsured: {
    id: 'medical-vertebral-fractures-second-insured',
    questionRef: 'medicalVertebralFracturesSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for vertebral fractures',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalOsteoporosisSecondInsured: {
    id: 'medical-osteoporosis-second-insured',
    questionRef: 'medicalOsteoporosisSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for osteoporosis',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalSystemicLupusSecondInsured: {
    id: 'medical-systemic-lupus-second-insured',
    questionRef: 'medicalSystemicLupusSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for systemic lupus',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalSclerodermaSecondInsured: {
    id: 'medical-scleroderma-second-insured',
    questionRef: 'medicalSclerodermaSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for scleroderma',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalRetinopathySecondInsured: {
    id: 'medical-retinopathy-second-insured',
    questionRef: 'medicalRetinopathySecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for retinopathy',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalLossOfVisionSecondInsured: {
    id: 'medical-loss-of-vision-second-insured',
    questionRef: 'medicalLossOfVisionSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for loss of vision',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalWetMacularDegenerationSecondInsured: {
    id: 'medical-wet-macular-degeneration-second-insured',
    questionRef: 'medicalWetMacularDegenerationSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for wet macular degeneration',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalKaposiSarcomaSecondInsured: {
    id: 'medical-kaposi-sarcoma-second-insured',
    questionRef: 'medicalKaposiSarcomaSecondInsured',
    title:
      "During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for Kaposi's sarcoma",
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalPneumocystisCariniiPneumoniaSecondInsured: {
    id: 'medical-pneumocystis-carinii-pneumonia-second-insured',
    questionRef: 'medicalPneumocystisCariniiPneumoniaSecondInsured',
    title:
      'During the past ten (10) years has the proposed insured been diagnosed by a member of the medical profession as having, had or been treated for pneumocystis carinii pneumonia',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
};
